import { useRef, useState } from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";
import InlineEdit from "./InlineEdit";
import { formatDate } from "../utils";

const useStyles = createUseStyles(theme => ({
  container: {
    position: "absolute",
    padding: theme.spacing2,
    bottom: 0,
    right: 0,
    backgroundColor: theme.colorBackground,
    borderRadius: [theme.borderRadius, 0, 0, 0],
    borderTop: `1px solid ${theme.colorDarkGrey}`,
    borderLeft: `1px solid ${theme.colorDarkGrey}`,
    zIndex: 5,
    color: "white",
    textAlign: "right",
  },
  name: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  lastSaved: {
    fontSize: "12px",
    color: "#ccc",
  },
  token: {
    color: theme.colorRed,
    fontSize: "16px",
    marginLeft: theme.spacing2,
    cursor: "pointer",
  },
  copy: {
    height: 1,
    width: 1,
    zIndex: -1,
    position: "absolute",
    bottom: 0,
    right: 0,
  },
  copied: {
    position: "absolute",
    right: 20,
    bottom: 45,
    color: "white",
    textAlign: "right",
    opacity: 0,
    zIndex: 10,
    pointerEvents: "none",
  },
  "@keyframes fadeinout": {
    from: {
      opacity: 1,
      bottom: 45,
    },
    to: {
      opaciy: 0,
      bottom: 70,
    },
  },
  active: {
    animation: "$fadeinout ease-out 1s forwards",
  },
}));

const TourInformation = ({ title, token, updatedAt, onUpdateTitle }) => {
  const [copied, setCopied] = useState(false);
  const classes = useStyles();
  const copyRef = useRef();

  const copy = () => {
    if (copyRef.current) {
      copyRef.current.value = `${window.location.origin}/tour/${token}`;
      copyRef.current.select();
      document.execCommand("copy");
      setCopied(true);
    }
  };

  return (
    <>
      <div className={clsx(classes.copied, { [classes.active]: copied })}>
        Copied link!
      </div>
      <div className={classes.container}>
        <div className={classes.name}>
          <InlineEdit
            tagName="span"
            value={title}
            onChange={value => onUpdateTitle(value)}
          />
          {token !== undefined && (
            <span className={classes.token} onClick={copy}>
              {token}
            </span>
          )}
        </div>
        <div className={classes.lastSaved}>
          {updatedAt ? formatDate(updatedAt) : "Never Saved"}
        </div>
      </div>
      <textarea readOnly className={classes.copy} type="text" ref={copyRef} />
    </>
  );
};

export default TourInformation;
